import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import type { CompareFunction } from 'webapp/enums/enums';

import FormSelectComponent from 'webapp/components/form/select';

import type DsCompare from 'webapp/models-custom/ds-compare';

interface Args {
	model: DsCompare;
	onChange: (compareFunction: CompareFunction) => void;
	isDisabled?: boolean;
}

export default class FormSelectCompareFunctionComponent extends Component<Args> {
	@service('constants') declare constantsService: Service.Constants;

	get options() {
		return this.constantsService.mkChangeFns;
	}
	<template>
		<div class="compare--function">
			<FormSelectComponent
				name="compareFunction"
				@selected={{@model.function}}
				@options={{this.options}}
				@isDisabled={{@isDisabled}}
				@placeholder="Change function"
				@tooltipOnSelectionFromProperty=""
				@isRequired={{true}}
				@isDropdownWider={{true}}
				@extraClass="dropdown-change-function"
				@onChange={{@onChange}}
			/>
		</div>
	</template>
}
